import angular from "angular";

angular
    .module('app')
    .component('attachFieldToClients', {
        template: require('./attach-field-to-clients.html'),
        controller: ['$http', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, $scope) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.organization = $ctrl.resolve.organization;
        $ctrl.clients = $ctrl.resolve.clients;
        $ctrl.fields = $ctrl.resolve.fields;

        $ctrl.clients.forEach(client => {
            client.status = null;
        });

        $ctrl.selectedField = null;
        $ctrl.editOnDirectory = false;
        $ctrl.editOnBooking = false;
        $ctrl.requiredOnBooking = false;
        $ctrl.customTitle = null;
        $ctrl.defaultValue = null;
    };

    $ctrl.delItem = (ind) => {
        if (confirm('Вы действительно хотите удалить со списка?')) {
            $ctrl.clients.splice(ind, 1);
        }
    };

    $ctrl.submit = async function () {
        for (let i = 0; i < $ctrl.clients.length; i++) {

            let client = $ctrl.clients[i];

            client.status = null;

            const params = {
                field_id: $ctrl.selectedField.id,
                custom_title: $ctrl.customTitle,
                default_value: $ctrl.defaultValue,
                edit_on_directory: $ctrl.editOnDirectory,
                edit_on_booking: $ctrl.editOnBooking,
                required_on_booking: $ctrl.requiredOnBooking,
            };

            try {
                await $http.post(`/control-panel/organizations/${$ctrl.organization.id}/clients/${client.id}/attach-field`, params);

                client.status = 'success';
            } catch (e) {
                client.status = 'error';
                client.errorMessage = e.data.message;
            }

            $scope.$apply();
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/attach-field-to-clients/attach-field-to-clients.js